import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30d65bd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ql-formats" }
const _hoisted_2 = {
  class: "ql-header",
  defaultValue: "0",
  style: {"width":"7.5rem"}
}
const _hoisted_3 = { value: "0" }
const _hoisted_4 = { value: "3" }
const _hoisted_5 = { value: "2" }
const _hoisted_6 = { value: "1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("select", { class: "ql-font" }, [
  /*#__PURE__*/_createElementVNode("option"),
  /*#__PURE__*/_createElementVNode("option", { value: "serif" }),
  /*#__PURE__*/_createElementVNode("option", { value: "monospace" })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ql-formats" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "ql-bold",
    type: "button"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    class: "ql-italic",
    type: "button"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    class: "ql-underline",
    type: "button"
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ql-formats" }, [
  /*#__PURE__*/_createElementVNode("select", { class: "ql-color" }),
  /*#__PURE__*/_createElementVNode("select", { class: "ql-background" })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ql-formats" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "ql-list",
    value: "ordered",
    type: "button"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    class: "ql-list",
    value: "bullet",
    type: "button"
  })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ql-formats" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "ql-align",
    value: "",
    type: "button"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    class: "ql-align",
    value: "center",
    type: "button"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    class: "ql-align",
    value: "right",
    type: "button"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    class: "ql-align",
    value: "justify",
    type: "button"
  })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ql-formats" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "ql-link",
    type: "button"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    class: "ql-image",
    type: "button"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    class: "ql-code-block",
    type: "button"
  })
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ql-formats" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "ql-clean",
    type: "button"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Editor = _resolveComponent("Editor")!

  return (_openBlock(), _createBlock(_component_Editor, {
    modelValue: _ctx.currentValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentValue) = $event)),
    editorStyle: "height: 250px",
    onTextChange: _ctx.onChange
  }, {
    toolbar: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createElementVNode("select", _hoisted_2, [
          _createElementVNode("option", _hoisted_3, _toDisplayString(_ctx.$t("Squeeze.Validation.Email.FontSizeNormal")), 1),
          _createElementVNode("option", _hoisted_4, _toDisplayString(_ctx.$t("Squeeze.Validation.Email.FontHeadline1")), 1),
          _createElementVNode("option", _hoisted_5, _toDisplayString(_ctx.$t("Squeeze.Validation.Email.FontHeadline2")), 1),
          _createElementVNode("option", _hoisted_6, _toDisplayString(_ctx.$t("Squeeze.Validation.Email.FontHeadline3")), 1)
        ]),
        _hoisted_7
      ]),
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      _hoisted_12,
      _hoisted_13
    ]),
    _: 1
  }, 8, ["modelValue", "onTextChange"]))
}